module.exports = __webpack_public_path__ + "img/sticker-2.83feac92.png";